import { get } from 'lodash'

const period = {
  morning: 'Manhã',
  afternoon: 'Tarde',
  nigth: 'Noite'
}

export default (searchedBy, filters, agenda, level) => {
  if (level.id === 'others' && agenda.period) {
    filters['schedules']['period'] = agenda.period
    searchedBy.push(get(period, agenda.period))
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterBySchedulesPeriod.js